//sidebar assets
import blogThumb1 from 'assets/images/blog/post/blog-post-1.png';
import blogThumb2 from 'assets/images/blog/post/blog-post-2.png';
import blogThumb3 from 'assets/images/blog/post/blog-post-3.png';
import blogThumb4 from 'assets/images/blog/post/blog-post-4.png';
import blogThumb5 from 'assets/images/blog/post/blog-post-5.png'; 
import blogThumb6 from 'assets/images/blog/post/blog-post-6.png'; 

// blog grid posts
import blogPostThumb2 from 'assets/images/blog/post/blog-post-2.png';
import blogPostThumb1 from 'assets/images/blog/post/blog-post-1.png';
import blogPostThumb3 from 'assets/images/blog/post/blog-post-3.png';
import blogPostThumb4 from 'assets/images/blog/post/blog-post-4.png';
import blogPostThumb5 from 'assets/images/blog/post/blog-post-5.png'; 
import blogPostThumb6 from 'assets/images/blog/post/blog-post-6.png'; 

export default {
    posts: [
        {
            url: "/blog-single",
            title: "Now led tedious shy",
            body: "Answer misery adieus add wooded how nay men before though.Pretended belonging contented mrs suffering.",
            thumbnail: blogPostThumb1
        },
        {
            url: "/blog-single",
            title: "Pretended bet contented",
            body: "Answer misery adieus add wooded how nay men before though.Pretended belonging contented mrs suffering.",
            thumbnail: blogPostThumb2
        },
        {
            url: "/blog-single",
            title: "Wooded how teus led",
            body: "Answer misery adieus add wooded how nay men before though.Pretended belonging contented mrs suffering.",
            thumbnail: blogPostThumb3
        },
        {
            url: "/blog-single",
            title: "Adieus woed how nay",
            body: "Answer misery adieus add wooded how nay men before though.Pretended belonging contented mrs suffering.",
            thumbnail: blogPostThumb4
        },
        {
            url: "/blog-single",
            title: "contented ted loka",
            body: "Answer misery adieus add wooded how nay men before though.Pretended belonging contented mrs suffering.",
            thumbnail: blogPostThumb5
        },
        {
            url: "/blog-single",
            title: "Answer ery eus add",
            body: "Answer misery adieus add wooded how nay men before though.Pretended belonging contented mrs suffering.",
            thumbnail: blogPostThumb6
        },
    ],
    recentPosts: [
        {
            url: "/blog-single",
            title: "Now led tedious shy",
            thumbnail: blogThumb1
        },
        {
            url: "/blog-single",
            title: "Pretended bet contented",
            thumbnail: blogThumb2
        },
        {
            url: "/blog-single",
            title: "Wooded how teus led",
            thumbnail: blogThumb3
        },
        {
            url: "/blog-single",
            title: "Adieus woed how nay",
            thumbnail: blogThumb4
        },
        {
            url: "/blog-single",
            title: "contented ted loka",
            thumbnail: blogThumb5
        },
        {
            url: "/blog-single",
            title: "Answer ery eus add",
            thumbnail: blogThumb6
        },
    ],

    categories: [
        {
            url: "#",
            name: "Development",
            count: "20"
        },
        {
            url: "#",
            name: "Technology",
            count: "13"
        },
        {
            url: "#",
            name: "Crypto",
            count: "7"
        },
        {
            url: "#",
            name: "Bitcoin",
            count: "17"
        },
        {
            url: "#",
            name: "Landing",
            count: "8"
        },
        {
            url: "#",
            name: "SASS",
            count: "11"
        },
    ],

    tags: [
        {
            url: "#",
            name: "SASS",
            count: "11"
        },
        {
            url: "#",
            name: "Crypto" 
        },
        {
            url: "#",
            name: "Technology",
            count: "13"
        },
        {
            url: "#",
            name: "Bitcoin",
            count: "7"
        },
        {
            url: "#",
            name: "Payment",
            count: "17"
        },
        {
            url: "#",
            name: "Landing",
            count: "8"
        },
        
    ]
}